import(/* webpackMode: "eager" */ "/workspace/apps/home-webapp/src/app/en/about/@history/page.tsx");
